export const TermsOfUse = {
  ListPageHeaderTitle: '利用規約',
  DetailPageHeaderTitle: '利用規約詳細',
  ServiceTermsOfUseTitle: 'サービス利用規約',
  NotAgree: '(未同意)',
  Agree: '同意する',
  DisAgree: '同意しない',
  Lift: '同意を解除する',
  Buttons: {
    Agree: '同意する',
    DisAgree: '同意しない',
  },
  CancelTitle: '利用規約の同意を解除してよろしいですか？',
  CancelText: '利用規約に同意いただけないと、{0}機能はご利用できません。',
  CompleteCancelTitle: '利用規約の同意状態を解除しました。',
};
